import NiceModal, { useModal } from "@ebay/nice-modal-react";
import cx from "classnames";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import { decodeHtml } from "@/shared/lib/decodeHtml";
import { Button } from "@/shared/ui/Button";
import styles from "./RenameBoardModal.module.scss";

type RenameBoardModalProps = {
    boardName: string;
};

export const RenameBoardModal = NiceModal.create<RenameBoardModalProps>(({ boardName }) => {
    const { t } = useTranslation();
    const modal = useModal();
    const [name, setName] = useState(decodeHtml(boardName));

    const handleSubmit = () => {
        modal.resolve(name.trim());
        modal.remove();
    };

    const handleCancel = () => {
        modal.remove();
    };

    const handleChange = (e) => setName(e.target.value);
    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleSubmit();
    };
    const handleFocus = () => {
        canv.appInterface.inputFocused = 1;
    };
    const handleBlur = () => {
        canv.appInterface.inputFocused = 0;
    };

    return (
        <div className={styles.renameWindowWrapper} onClick={handleCancel}>
            <div className={styles.renameWindow} onClick={(e) => e.stopPropagation()}>
                <div className={styles.renameWindowAbout}>{t("renameBoard.title")}</div>

                <div className={styles.renameWindowName}>
                    <div className={styles.renameWindowNameWrapper}>
                        <input
                            className={styles.renameWindowNameWrapperField}
                            type="text"
                            placeholder={t("renameBoard.placeholder")}
                            value={name}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                        />
                    </div>
                </div>

                <div className={styles.renameWindowDescription}>
                    {t("renameBoard.descriptionLine1")}
                    <br />
                    {t("renameBoard.descriptionLine2")}
                </div>

                <div className={styles.renameWindowActions}>
                    <Button className={styles.renameWindowActionsItem} onClick={handleSubmit}>
                        {t("renameBoard.submit")}
                    </Button>

                    <Button
                        className={cx(
                            styles.renameWindowActionsItem,
                            styles.renameWindowActionsItemBack,
                        )}
                        variant="tertriary"
                        onClick={handleCancel}
                    >
                        {t("renameBoard.cancel")}
                    </Button>
                </div>
            </div>
        </div>
    );
});
